// Returns new object without the provided key
const omit = (obj, key) => {
  if (obj) {
    const newObj = {}
    Object.keys(obj).forEach((k) => {
      if (key !== k) {
        newObj[k] = obj[k]
      }
    })
    return newObj
  }

  return obj
}

export default omit
